import PropTypes from "prop-types";
import Text from "components/Common/Text";

import Increase from "assets/increase.svg";

export default function EditTeesListHeader({ onClose, courseName }) {
  return (
    <div
      style={{
        backgroundColor: "#1B4F6D",
        padding: 10,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        borderTopLeftRadius: 16,
        borderTopRightRadius: 16,
      }}
    >
      <Text>⛳️ {courseName}</Text>
      <button
        type="button"
        style={{
          backgroundColor: "transparent",
        }}
        aria-hidden
        onClick={() => onClose()}
      >
        <img
          style={{ transform: "rotate(45deg)" }}
          src={Increase}
          alt="close modal"
        />
      </button>
    </div>
  );
}

EditTeesListHeader.propTypes = {
  courseName: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
};
